export const initialData = {
  pode_elaboracao_e_estudo_projeto: undefined,
  pode_elaboracao_orcamento: undefined,
  pode_implantacao_estudo_e_projeto: undefined,
  pode_execucao_estudo_e_projeto: undefined,
  pode_fiscalizacao_estudo_e_projeto: undefined,
  pode_monitoramento_estudo_e_projeto: undefined,
};
export default initialData;
